"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetFileExtension = exports.isAsset3DFileType = exports.ASSET_3D_FILE_TYPES = exports.AssetFileType = void 0;
var AssetFileType;
(function (AssetFileType) {
    AssetFileType["FBX"] = "fbx";
    AssetFileType["PNG"] = "png";
    AssetFileType["JPG"] = "jpg";
    AssetFileType["GLTF"] = "gltf";
})(AssetFileType || (exports.AssetFileType = AssetFileType = {}));
exports.ASSET_3D_FILE_TYPES = [
    AssetFileType.FBX,
    AssetFileType.GLTF,
];
var isAsset3DFileType = function (fileType) {
    return exports.ASSET_3D_FILE_TYPES.includes(fileType);
};
exports.isAsset3DFileType = isAsset3DFileType;
/*
 * A utility function to get the file extension of a filename
 */
function getAssetFileExtension(fileName) {
    var ext = fileName.split(".").slice(-1)[0];
    if (!Object.values(AssetFileType).includes(ext)) {
        throw new Error("Invalid file extension ".concat(ext));
    }
    return ext;
}
exports.getAssetFileExtension = getAssetFileExtension;
